import styled from 'styled-components';

export const CcImg = styled.img<{ active: boolean }>`
  opacity: ${(props) => (props.active ? '1' : '0.3')};
  width: 36px;
  margin-left: 5px;
`;
